import PropTypes from 'prop-types';
import {
  useMemo,
} from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { useAuth } from '../../stores';

import LoginPage from './LoginPage';
import RequireAuth from './RequireAuth';

function LoginSwitch(props) {
  const {
    children,
  } = props;
  const { auth } = useAuth();
  const { authStatus, info } = auth;

  // Check if user is logged in (not a demo user)
  const loggedIn = useMemo(
    () => {
      const ret = (authStatus === 'loggedIn') && info?.privlg && !info.privlg.includes('demo');

      return (ret);
    },
    [authStatus, info],
  );

  const location = useLocation();

  const [searchParams] = useSearchParams();

  // Create a searchParams object for the logged-out path
  const modifiedSearchParams = useMemo(
    () => {
      const newSearchParams = new URLSearchParams(searchParams);
      const dest = searchParams.get('dest');

      // Set destination for after login
      if (!dest && location.pathname === '/login') {
        newSearchParams.set('dest', '/home');
      } else if (!dest) {
        newSearchParams.set('dest', location.pathname);
      }

      return newSearchParams;
    },
    [location.pathname, searchParams],
  );

  // Path to redirect to when logged in
  const loggedInPath = useMemo(
    () => {
      const dest = searchParams.get('dest') || '/home';

      const filteredParams = new URLSearchParams(searchParams);
      filteredParams.delete('dest');

      const queryString = filteredParams.toString();
      return dest + (queryString ? `?${queryString}` : '');
    },
    [searchParams],
  );

  // Path to redirect to when logged out
  const loggedOutPath = useMemo(
    () => {
      const queryString = modifiedSearchParams.toString();
      return `/login${queryString ? `?${queryString}` : ''}`;
    },
    [modifiedSearchParams],
  );

  return (
    <Routes>
      <Route
        path="/login"
        element={
          loggedIn
            ? <Navigate to={loggedInPath} />
            : <LoginPage />
        }
      />

      <Route
        path="*"
        element={(
          <RequireAuth redirectTo={loggedOutPath}>
            {children}
          </RequireAuth>
        )}
      />

    </Routes>
  );
}

LoginSwitch.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LoginSwitch;
